import React, { useState, useEffect } from "react";
import { apiGet, apiPost, apiPut } from "../Utils/apiFetch";
import { apiPath } from "../Utils/apiPath";
import { isEmpty } from "lodash";
import { toast } from "react-toastify";
import Pagination from "../components/Pagination";

const Ticket = () => {
  const [tickerData, setTickerData] = useState([]);
  const [isLoader, setLoader] = useState(false);
  const [filter, setFilter] = useState({
    page: 1,
 limit: 10,
  });

  // Add New Ticker
  const [showAddModal, setShowAddModal] = useState(false);
  const [newTitle, setNewTitle] = useState("");
  const [newIsActive, setNewIsActive] = useState(false);

  // Edit Ticker
  const [showEditModal, setShowEditModal] = useState(false);
  const [editId, setEditId] = useState("");
  const [editTitle, setEditTitle] = useState("");
  const [editIsActive, setEditIsActive] = useState(false);

  // Row selection (select_all + per row) for Delete
  const [tickerIds, setTickerIds] = useState([]);
  const getTickerData = async (activeFilter) => {
    const { status, data: response_users } = await apiGet(
      apiPath.userMessageList,
      activeFilter,
    );
    if (status === 200) {
      if (response_users.success) {
        setTickerData(response_users.results);
      }
    }
  };
  console.log(tickerIds, "tickerIds");
  useEffect(() => {
    getTickerData(filter);
  }, [filter.page]);

  const setCheckBoxData = (id) => {
    const newTickerIds = [...tickerIds];
    const index = newTickerIds.indexOf(id);
    if (index === -1) {
      newTickerIds.push(id);
    } else {
      newTickerIds.splice(index, 1);
    }
    setTickerIds(newTickerIds);
  };
  const handlePageChange = (newPage) => {
    setFilter((prev) => ({ ...prev, page: newPage }));
  };
  const setSelectAll = (e) => {
    if (e.target.checked) {
      setTickerIds(tickerData?.data?.map((item) => item?._id) || []);
    } else {
      setTickerIds([]);
    }
  };

  const handleDelete = async () => {
    if (tickerIds && tickerIds.length) {
      const { status, data: response_users } = await apiPut(
        apiPath.messageStatusUpdate,
        { messageId: tickerIds, status: "delete" },
      );
      if (status === 200) {
        if (response_users.success) {
          setTickerIds([]);
          toast.success(response_users.message);
          getTickerData();
        } else {
          toast.error(response_users.message);
        }
      }
    } else {
      toast.error("Please select ticker");
    }
  };

  const openAddModal = () => {
    setNewTitle("");
    setNewIsActive(false);
    setShowAddModal(true);
  };

  const closeAddModal = () => {
    setShowAddModal(false);
  };

  const onSubmitAdd = async () => {
    if (!newTitle) {
      toast.error("Please enter title");
      return;
    }
    setLoader(true);
    try {
      const { status, data: response_users } = await apiPost(
        apiPath.userMessageCreate,
        { title: newTitle, isActive: newIsActive },
      );
      if (status === 200) {
        if (response_users.success) {
          setLoader(false);
          toast.success(response_users.message);
          setNewTitle("");
          setNewIsActive(false);
          setShowAddModal(false);
          getTickerData();
        } else {
          setLoader(false);
          toast.error(response_users.message);
        }
      }
    } catch (err) {
      setLoader(false);
      toast.error(err.response.data.message);
    }
  };

  const setDataForEdit = (id, title, isActive) => {
    setEditId(id);
    setEditTitle(title);
    setEditIsActive(isActive);
    setShowEditModal(true);
  };

  const closeEditModal = () => {
    setShowEditModal(false);
  };

  const onSubmitEdit = async () => {
    if (!editTitle) {
      toast.error("Please enter title");
      return;
    }
    setLoader(true);
    try {
      const { status, data: response_users } = await apiPut(
        apiPath.userMessageUpdate,
        { messageId: editId, title: editTitle, isActive: editIsActive },
      );
      if (status === 200) {
        if (response_users.success) {
          setLoader(false);
          toast.success(response_users.message);
          setShowEditModal(false);
          getTickerData();
        } else {
          setLoader(false);
          toast.error(response_users.message);
        }
      }
    } catch (err) {
      setLoader(false);
      toast.error(err.response.data.message);
    }
  };

  return (
    <app-ticker _nghost-serverapp-c94 className="ng-star-inserted">
      <div _ngcontent-serverapp-c94 className="main_wrap">
        <h2 _ngcontent-serverapp-c94>Ticker</h2>

        <div _ngcontent-serverapp-c94 className="function-wrap funwrap">
          <div _ngcontent-serverapp-c94>
            <button
              _ngcontent-serverapp-c94
              className="btn"
              onClick={handleDelete}
            >
              Delete
            </button>
            <span _ngcontent-serverapp-c94 className="spacer" />
            <a
              _ngcontent-serverapp-c94
              className="btn-send"
              onClick={openAddModal}
            >
              Add New
            </a>
          </div>
          <div _ngcontent-serverapp-c94>
            <span _ngcontent-serverapp-c94 className="spacer" />
            <p _ngcontent-serverapp-c94 className="vertical-align: middle">
              Total Records: {tickerData?.totalDocs || 0}
            </p>
          </div>
        </div>
        <div _ngcontent-serverapp-c94 className="table-container">
          <table _ngcontent-serverapp-c94 className="table01">
            <thead _ngcontent-serverapp-c94>
              <tr _ngcontent-serverapp-c94 className="ng-table-sort-header">
                <th _ngcontent-serverapp-c94 width="3%">
                  <div
                    _ngcontent-serverapp-c94
                    ng-if="template"
                    ng-include="template"
                  >
                    <input
                      _ngcontent-serverapp-c94
                      type="checkbox"
                      id="select_all"
                      name="filter-checkbox"
                      checked={
                        tickerData?.data?.length > 0 &&
                        tickerIds.length === tickerData?.data?.length
                      }
                      onChange={setSelectAll}
                    />
                  </div>
                </th>
                <th _ngcontent-serverapp-c94 width="3%">
                  Edit
                </th>
                <th _ngcontent-serverapp-c94 width="10%" className="align-L">
                  id
                </th>
                <th _ngcontent-serverapp-c94 className="align-L">
                  Ticker
                </th>
                <th _ngcontent-serverapp-c94 width="8%" className="align-L">
                  Is Active
                </th>
              </tr>
            </thead>
            <tbody _ngcontent-serverapp-c94 className="ng-star-inserted">
              {tickerData?.data?.length > 0 ? (
                tickerData?.data?.map((item, index) => {
                  return (
                    <tr _ngcontent-serverapp-c94 key={item?._id || index}>
                      <td _ngcontent-serverapp-c94>
                        <input
                          _ngcontent-serverapp-c94
                          type="checkbox"
                          name="filter-checkbox"
                          checked={tickerIds.includes(item?._id)}
                          onChange={() => setCheckBoxData(item?._id)}
                        />
                      </td>
                      <td _ngcontent-serverapp-c94>
                        <a
                          _ngcontent-serverapp-c94
                          className="btn-send"
                          onClick={() =>
                            setDataForEdit(
                              item?._id,
                              item?.title,
                              item?.status == "open" ? true : false,
                            )
                          }
                        >
                          Edit
                        </a>
                      </td>
                      <td _ngcontent-serverapp-c94 className="align-L">
                        {item?._id}
                      </td>
                      <td _ngcontent-serverapp-c94 className="align-L">
                        {item?.title || "N/A"}
                      </td>
                      <td _ngcontent-serverapp-c94 className="align-L">
                        {item?.status == "open" ? "True" : "False"}
                      </td>
                    </tr>
                  );
                })
              ) : (
                <tr _ngcontent-serverapp-c94>
                  <td _ngcontent-serverapp-c94 colSpan={5} className="align-C">
                    <em _ngcontent-serverapp-c94>No Message</em>
                  </td>
                </tr>
              )}
            </tbody>
          </table>
        </div>
        {tickerData?.data?.length > 0 && tickerData?.totalDocs > 0 && (
          <Pagination pagination={tickerData} onPageChange={handlePageChange} />
        )}
      </div>
      <app-modal _ngcontent-serverapp-c94 _nghost-serverapp-c43>
        <div
          _ngcontent-serverapp-c43
          id="createModal"
          className="pop_bg"
          style={{
            height: "100%",
            width: "100%",
            display: showAddModal ? "block" : "none",
          }}
        >
          <div _ngcontent-serverapp-c43 className="pop_box pop_refer">
            <a
              _ngcontent-serverapp-c43
              href="#"
              className="close_pop ng-star-inserted"
              onClick={closeAddModal}
            >
              close_pop
            </a>

            <div _ngcontent-serverapp-c94 className="modal-header">
              <h3 _ngcontent-serverapp-c94>Add New Ticker</h3>
            </div>
            <div _ngcontent-serverapp-c94 className="modal-content">
              <div _ngcontent-serverapp-c94 className="ticker-details">
                <div _ngcontent-serverapp-c94 className="input-group">
                  <label
                    _ngcontent-serverapp-c94
                    htmlFor="title"
                    style={{ display: "block" }}
                  >
                    Title:{" "}
                  </label>
                  <textarea
                    _ngcontent-serverapp-c94
                    rows={10}
                    cols={50}
                    className="ng-untouched ng-pristine ng-valid"
                    value={newTitle}
                    onChange={(e) => setNewTitle(e.target.value)}
                  />
                </div>
                <div _ngcontent-serverapp-c94 className="containerisactive">
                  <label _ngcontent-serverapp-c94 htmlFor="isActive">
                    <input
                      _ngcontent-serverapp-c94
                      type="checkbox"
                      name="isActive"
                      id="isActive"
                      className="ng-untouched ng-pristine ng-valid"
                      checked={newIsActive}
                      onChange={(e) => setNewIsActive(e.target.checked)}
                    />{" "}
                    Is Active{" "}
                  </label>
                </div>
              </div>
            </div>
            <div _ngcontent-serverapp-c94 className="modal-footer">
              <div _ngcontent-serverapp-c94 className="btn_box">
                <button
                  _ngcontent-serverapp-c94
                  className="btn-send"
                  style={{ width: "100%" }}
                  onClick={onSubmitAdd}
                >
                  {isLoader ? "Loading..." : "Add New"}
                </button>
              </div>
            </div>
          </div>
        </div>
      </app-modal>
      <app-modal _ngcontent-serverapp-c94 _nghost-serverapp-c43>
        <div
          _ngcontent-serverapp-c43
          id="createModal"
          className="pop_bg"
          style={{
            height: "100%",
            width: "100%",
            display: showEditModal ? "block" : "none",
          }}
        >
          <div _ngcontent-serverapp-c43 className="pop_box pop_refer">
            <a
              _ngcontent-serverapp-c43
              href="#"
              className="close_pop ng-star-inserted"
              onClick={closeEditModal}
            >
              close_pop
            </a>

            <div _ngcontent-serverapp-c94 className="modal-header">
              <h3 _ngcontent-serverapp-c94>Edit Ticker</h3>
            </div>
            <div _ngcontent-serverapp-c94 className="modal-content">
              <div _ngcontent-serverapp-c94 className="ticker-details">
                <div _ngcontent-serverapp-c94 className="input-group">
                  <label
                    _ngcontent-serverapp-c94
                    htmlFor="title"
                    style={{ display: "block" }}
                  >
                    Title:{" "}
                  </label>
                  <textarea
                    _ngcontent-serverapp-c94
                    rows={10}
                    cols={50}
                    className="ng-untouched ng-pristine ng-valid"
                    value={editTitle}
                    onChange={(e) => setEditTitle(e.target.value)}
                  />
                </div>
                <div _ngcontent-serverapp-c94 className="container">
                  <label _ngcontent-serverapp-c94 htmlFor="isActive">
                    <input
                      _ngcontent-serverapp-c94
                      type="checkbox"
                      name="isActive"
                      id="isActive"
                      className="ng-untouched ng-pristine ng-valid"
                      checked={editIsActive}
                      onChange={(e) => setEditIsActive(e.target.checked)}
                    />{" "}
                    Is Active{" "}
                  </label>
                </div>
              </div>
            </div>
            <div _ngcontent-serverapp-c94 className="modal-footer">
              <div _ngcontent-serverapp-c94 className="btn_box">
                <button
                  _ngcontent-serverapp-c94
                  className="btn-send"
                  style={{ width: "100%" }}
                  onClick={onSubmitEdit}
                >
                  {isLoader ? "Loading..." : "Edit"}
                </button>
              </div>
            </div>
          </div>
        </div>
      </app-modal>
    </app-ticker>
  );
};

export default Ticket;
